import React from "react";
import axios from "axios";
// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";

// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

// Require Font Awesome.
import "font-awesome/css/font-awesome.css";

import FroalaEditor from "react-froala-wysiwyg";
import { DOMAIN } from "../../utils/constant";
import Cookies from "js-cookie";

// Include special components if required.
// import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
// import FroalaEditorA from 'react-froala-wysiwyg/FroalaEditorA';
// import FroalaEditorButton from 'react-froala-wysiwyg/FroalaEditorButton';
// import FroalaEditorImg from "react-froala-wysiwyg/FroalaEditorImg";
// import FroalaEditorInput from 'react-froala-wysiwyg/FroalaEditorInput';

class TextEditor extends React.Component {
  constructor(props) {
    super(props);

    console.log(":::::", props);

    this.baseURL = DOMAIN + "api/";
    this.menu = [
      "undo",
      "redo",
      "print",
      "|",
      "fontFamily",
      "fontSize",
      "bold",
      "italic",
      "underline",
      "strikeThrough",
      "subscript",
      "superscript",
      "|",
      "specialCharacters",
      "color",
      "emoticons",
      "-",
      "paragraphFormat",
      "align",
      "formatOL",
      "formatUL",
      "quote",
      "insertHR",
      "-",
      "insertLink",
      "insertImage",
      "insertTable",
      "html",
    ];
    this.config = {
      key: "UC11D6E6C5D4H4fG3A7A6B5A3C3E3G3C2E2yIBEVFBOHC1d2UNYVM==",
      language: "zh_cn",
      placeholderText: "在这里编辑正文",
      height: 900,
      charCounterCount: true,
      toolbarInline: false,
      toolbarButtons: this.menu,
      toolbarButtonsMD: this.menu,
      toolbarButtonsSM: this.menu,
      toolbarButtonsXS: this.menu,
      imageDefaultAlign: "center",
      imageDefaultWidth: 0,
      imageDefaultDisplay: "block",
      colorsText: [
        "#99ff33",
        "#1ABC9C",
        "#54ACD2",
        "#2C82C9",
        "#9365B8",
        "#475577",
        "#CCCCCC",
        "#41A85F",
        "#00dd00",
        "#9900FF",
        "#0000DD",
        "#553982",
        "#28324E",
        "#000000",
        "#F7DA64",
        "#FBA026",
        "#EB6B56",
        "#dd0000",
        "#A38F84",
        "#EFEFEF",
        "#FFFFFF",
        "#ffff00",
        "#F37934",
        "#cc0000",
        "#ff0000",
        "#7C706B",
        "#D1D5D8",
        "REMOVE",
      ],
      colorsBackground: ["#61BD6D", "#1ABC9C", "#54ACD2", "REMOVE"],
      fontFamily: {
        "Arial,Helvetica,sans-serif": "Arial",
        "Georgia,serif": "Georgia",
        "Impact,Charcoal,sans-serif": "Impact",
        "Tahoma,Geneva,sans-serif": "Tahoma",
        "'Times New Roman',Times,serif": "Times New Roman",
      },
      videoResponsive: true,
      videoUpload: false,
      imageStyles: {
        w100: "w-100",
      },
      imageResize: true,
      imageMaxSize: 1024 * 1024 * 50,
      requestHeaders: {
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      },
      // requestWithCORS: true,
      // upload images
      imageUploadMethod: "POST",
      imageUploadParams: { classified_ad_id: props.postId, is_froala: true },
      imageUploadURL:
        this.baseURL + "dashboard/froala/image/upload/classified_gg",
      imageUploadParam: "image",
      // upload fiile
      // fileUploadParams: { post_id: props.postId, is_froala: true },
      // fileUploadURL: this.baseURL + "/upload-post-file",
      //load images
      // imageManagerLoadMethod: "GET",
      // imageManagerLoadParams: { post_id: props.postId },
      imageManagerLoadURL:
        this.baseURL +
        "dashboard/froala/images/classified_gg?classified_ad_id=" +
        props.postId,
      // delete images
      imageManagerDeleteURL: this.baseURL + "dashboard/froala/image/remove",
      imageManagerDeleteMethod: "POST",
      events: {
        "froalaEditor.initialized": function () {
          // console.log("initialized");
        },
        "froalaEditor.image.uploaded": function (e, editor, response) {
          // Do something here.
          // console.log(e);
        },
      },
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.postId !== this.props.postId) {
      console.log(newProps.postId, "esfbhsuebfusbfue");
      this.config = {
        key: "UC11D6E6C5D4H4fG3A7A6B5A3C3E3G3C2E2yIBEVFBOHC1d2UNYVM==",
        language: "zh_cn",
        placeholderText: "在这里编辑正文",
        height: 900,
        charCounterCount: true,
        toolbarInline: false,
        toolbarButtons: this.menu,
        toolbarButtonsMD: this.menu,
        toolbarButtonsSM: this.menu,
        toolbarButtonsXS: this.menu,
        imageDefaultAlign: "center",
        imageDefaultWidth: 0,
        imageDefaultDisplay: "block",
        colorsText: [
          "#99ff33",
          "#1ABC9C",
          "#54ACD2",
          "#2C82C9",
          "#9365B8",
          "#475577",
          "#CCCCCC",
          "#41A85F",
          "#00dd00",
          "#9900FF",
          "#0000DD",
          "#553982",
          "#28324E",
          "#000000",
          "#F7DA64",
          "#FBA026",
          "#EB6B56",
          "#dd0000",
          "#A38F84",
          "#EFEFEF",
          "#FFFFFF",
          "#ffff00",
          "#F37934",
          "#cc0000",
          "#ff0000",
          "#7C706B",
          "#D1D5D8",
          "REMOVE",
        ],
        colorsBackground: ["#61BD6D", "#1ABC9C", "#54ACD2", "REMOVE"],
        fontFamily: {
          "Arial,Helvetica,sans-serif": "Arial",
          "Georgia,serif": "Georgia",
          "Impact,Charcoal,sans-serif": "Impact",
          "Tahoma,Geneva,sans-serif": "Tahoma",
          "'Times New Roman',Times,serif": "Times New Roman",
        },
        videoResponsive: true,
        videoUpload: false,
        imageStyles: {
          w100: "w-100",
        },
        imageResize: true,
        imageMaxSize: 1024 * 1024 * 50,
        requestHeaders: {
          Authorization: "Bearer" + " " + Cookies.get("access_token"),
        },
        // requestWithCORS: true,
        // upload images
        imageUploadMethod: "POST",
        imageUploadParams: { post_id: newProps.postId, is_froala: true },
        imageUploadURL: this.baseURL + "dashboard/froala/image/upload",
        imageUploadParam: "image",
        // upload fiile
        // fileUploadParams: { post_id: props.postId, is_froala: true },
        // fileUploadURL: this.baseURL + "/upload-post-file",
        //load images
        // imageManagerLoadMethod: "GET",
        // imageManagerLoadParams: { post_id: props.postId },
        imageManagerLoadURL:
          this.baseURL + "dashboard/froala/images?post_id=" + newProps.postId,
        // delete images
        imageManagerDeleteURL: this.baseURL + "dashboard/froala/image/remove",
        imageManagerDeleteMethod: "POST",
        events: {
          "froalaEditor.initialized": function () {
            // console.log("initialized");
          },
          "froalaEditor.image.uploaded": function (e, editor, response) {
            // Do something here.
            // console.log(e);
          },
        },
      };
    }
  }

  render() {
    return (
      <div className="mb-4">
        <FroalaEditor
          config={this.config}
          model={this.props.content}
          onModelChange={this.props.onContentChange}
        />
      </div>
    );
  }
}

export default TextEditor;
